import React from 'react';
import { motion } from 'framer-motion';
import { CameraIcon, VideoIcon, LayersIcon } from 'lucide-react';
interface MobileTaskbarProps {
  currentCategory: string;
  onCategoryChange: (category: string) => void;
}
const MobileTaskbar: React.FC<MobileTaskbarProps> = ({
  currentCategory,
  onCategoryChange
}) => {
  const categories = [{
    id: 'all',
    label: 'Alle',
    icon: null,
    color: 'bg-gray-100',
    textColor: 'text-gray-900'
  }, {
    id: 'Photo',
    label: 'Foto',
    icon: CameraIcon,
    color: 'bg-rose-100',
    textColor: 'text-rose-900'
  }, {
    id: 'Video',
    label: 'Video',
    icon: VideoIcon,
    color: 'bg-indigo-100',
    textColor: 'text-indigo-900'
  }, {
    id: 'Motion Design',
    label: 'Motion',
    icon: LayersIcon,
    color: 'bg-violet-100',
    textColor: 'text-violet-900'
  }];
  return <div className="flex items-center justify-between p-3 border-t" data-id="element-216">
      {categories.map(category => {
      const Icon = category.icon;
      const isActive = currentCategory === category.id;
      return <motion.button key={category.id} onClick={() => onCategoryChange(category.id)} className={`relative flex-1 mx-1 px-2 py-2.5 rounded-xl flex items-center justify-center gap-1.5
              ${isActive ? category.textColor : 'text-gray-500'}`} whileTap={{
        scale: 0.92
      }} data-id="element-217">
            {Icon && <Icon className="w-4 h-4" data-id="element-218" />}
            <span className="font-medium text-sm" data-id="element-219">{category.label}</span>
            {isActive && <motion.div layoutId="active-category" className={`absolute inset-0 -z-10 rounded-xl ${category.color} bg-opacity-80`} transition={{
          type: 'spring',
          stiffness: 500,
          damping: 35
        }} data-id="element-220" />}
          </motion.button>;
    })}
    </div>;
};
export default MobileTaskbar;